import { createAsyncActionType } from '.';

export const STATS_USER_LIST = createAsyncActionType(
  'statistics',
  'STATS_USER_LIST'
);

export const USER_STATS_GET = createAsyncActionType(
  'statistics',
  'USER_STATS_GET'
);

export const USER_COURSES_GET = createAsyncActionType(
  'statistics',
  'USER_COURSES_GET'
);

export const USER_GROUPS_GET = createAsyncActionType(
  'statistics',
  'USER_GROUPS_GET'
);

export const COURSE_STATS_GET = createAsyncActionType(
  'statistics',
  'COURSE_STATS_GET'
);

export const COURSE_ACTIVITIES_GET = createAsyncActionType(
  'statistics',
  'COURSE_ACTIVITIES_GET'
);

export const EVENT_SESSIONS_GET = createAsyncActionType(
  'statistics',
  'EVENT_SESSIONS_GET'
);

export const COURSE_USERS_GET = createAsyncActionType(
  'statistics',
  'COURSE_USERS_GET'
);
export const EVENT_USERS_GET = createAsyncActionType(
  'statistics',
  'EVENT_USERS_GET'
);
export const STATS_USERS_RESET = '@@statistics/STATS_USERS_RESET';

export const COURSE_USERS_ACTIVITIES_GET = createAsyncActionType(
  'statistics',
  'COURSE_USERS_ACTIVITIES_GET'
);

export const EVENT_USERS_ACTIVITIES_GET = createAsyncActionType(
  'statistics',
  'EVENT_USERS_ACTIVITIES_GET'
);

export const COURSE_USERS_ACTIVITIES_RESET =
  '@@statistics/COURSE_USERS_ACTIVITIES_RESET';

export const STATS_GROUP_LIST_GET = createAsyncActionType(
  'statistics',
  'STATS_GROUP_LIST_GET'
);

export const GROUP_COURSES_GET = createAsyncActionType(
  'statistics',
  'GROUP_COURSES_GET'
);

export const SAVE_PRINT_SETTINGS = '@@statistics/SAVE_PRINT_SETTINGS';

export const MY_COURSES_GET = createAsyncActionType(
  'statistics',
  'MY_COURSES_GET'
);
//* csv charts
export const MULTI_PRINT_MY_CHARTS_CSV = createAsyncActionType(
  'statistics',
  'MULTI_PRINT_MY_CHARTS_CSV'
);
export const PRINT_ACCESS_CSV = createAsyncActionType(
  'statistics',
  'PRINT_ACCESS_CSV'
);
export const PRINT_MY_TUTORS_CSV = createAsyncActionType(
  'statistics',
  'PRINT_MY_TUTORS_CSV'
);
export const PRINT_CATEGORIES_CSV = createAsyncActionType(
  'statistics',
  'PRINT_CATEGORIES_CSV'
);
export const PRINT_COURSES_CSV = createAsyncActionType(
  'statistics',
  'PRINT_COURSES_CSV'
);
export const PRINT_ACTIVITIES_CSV = createAsyncActionType(
  'statistics',
  'PRINT_ACTIVITIES_CSV'
);

//* others
export const MULTI_PRINT_MY_COURSES = createAsyncActionType(
  'statistics',
  'MULTI_PRINT_MY_COURSES'
);

export const MY_USERS_GET = createAsyncActionType('statistics', 'MY_USERS_GET');

export const MULTI_PRINT_MY_USERS = createAsyncActionType(
  'statistics',
  'MULTI_PRINT_MY_USERS'
);

export const COURSE_CREATED_LIST_GET = createAsyncActionType(
  'statistics',
  'COURSE_CREATED_LIST_GET'
);
export const COURSE_CREATED_LIST_RESET =
  '@@statistics/COURSE_CREATED_LIST_RESET';

export const SURVEY_STATS_GET = createAsyncActionType(
  'statistics',
  'SURVEY_STATS_GET'
);

export const SURVEY_FREE_TEXT_ANSWERS_GET = createAsyncActionType(
  'statistics',
  'SURVEY_FREE_TEXT_ANSWERS_GET'
);

export const PRINT_SETTINGS_RESET = '@@statistics/PRINT_SETTINGS_RESET';

export const PRINT_MY_TUTORS = createAsyncActionType(
  'statistics',
  'PRINT_MY_TUTORS'
);

export const PRINT_MY_CATEGORIES = createAsyncActionType(
  'statistics',
  'PRINT_MY_CATEGORIES'
);

export const MULTI_PRINT_MY_ACTIVITIES = createAsyncActionType(
  'statistics',
  'MULTI_PRINT_MY_ACTIVITIES'
);
